


//设备分类统计饼图
export let opt_devices = {
    title: {
        text: "设备分类统计",
    },
    tooltip: {
        trigger: 'item',
        formatter: '{b}：{c}'
    },
    graphic: {
        elements: [
            {
                type: 'text',
                left: 'center',
                top: '48%',
                left: "53%",
                style: {
                    text: '',//中心文本
                    textAlign: 'center',
                    fill: '#000',
                    width: 30,
                    height: 30,
                    fontSize: 25,
                }
            }
        ]
    },
    legend: {
        orient: 'vertical',
        left: 'right',
        top: 'middle'
    },
    series: [
        {
            right: '20%',
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
                alignTo: 'labelLine',
                formatter: '{a|{b}}',
                // color: '#333',
                // fontSize: 5,
                // fontFamily: 'Arial',
                // borderWidth: 3,
                // backgroundColor: '#984455',
                // padding: [3, 10, 10, 5],
                // lineHeight: 20,
                rich: {
                    a: {
                        fontSize: 10,
                        align: 'right',
                        width: '100%'
                    }
                }
            },
            data: [],//填充数据
            emphasis: {
                label: {
                    show: true,
                }
            },
            labelLine: {
                show: true,
                smooth: true
            },
        }
    ]
};


// 巡检统计柱状图
export let opt_inspection = {
    title: {
        text: "巡检统计",
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [],//
    yAxis: { show: false },
    series: []//
};

export let opt_repair = {
    title: {
        text: "维修成本统计",
    },
    xAxis: {
        type: 'category',
        data: []
    },
    legend:{},
    tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    yAxis: {
        type: 'value'
    },
    series: [{
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'line'
    }]
}

export let opt_upkeep = {
    title: {
        text: "维保成本统计",
    },
    xAxis: {
        type: 'category',
        data: [],
    },
    tooltip:{
        show:true,
        trigger: 'axis',
    },
    yAxis: {
        type: 'value'
    },
    series: [{
        data: [],
        type: 'line',
        name:'维保费用',
        areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#409EFF'
            }, {
                offset: 1,
                color: '#fff'
            }])
        },
    }]
}